import { render, staticRenderFns } from "./quality.vue?vue&type=template&id=2d8805e3&scoped=true&"
import script from "./quality.vue?vue&type=script&lang=js&"
export * from "./quality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8805e3",
  null
  
)

export default component.exports